import { render, staticRenderFns } from "./StudentHomeworkList.vue?vue&type=template&id=b31df934&scoped=true&"
import script from "./StudentHomeworkList.vue?vue&type=script&lang=js&"
export * from "./StudentHomeworkList.vue?vue&type=script&lang=js&"
import style0 from "./StudentHomeworkList.vue?vue&type=style&index=0&id=b31df934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31df934",
  null
  
)

export default component.exports